module.exports = __webpack_public_path__ + "assets/7d4ce18a4823a3c376e606119b63a828.png";